import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_OFFICE_BUTTON: `${cleanedFilename(__filename)}-add-office-button`,
};
